import getTaskType from '../../utils/getTaskType';

class TaskDelayed {
  constructor(task = {}) {
    this.id = task.id || '';
    this.extId = task.extId || '';

    this.type = task.type || getTaskType(false, false, true);

    this.title = task.title || '';
    this.subtitle = task.subtitle || '';
    this.description = task.description || '';
    this.note = task.note || '';

    this.importance = task.importance || false;
    this.done = task.done || false;

    this.singleTaskId = task.singleTaskId || null;

    this.labels = task.labels || [];
  }

  getCreateTaskDelayedDto() {
    const serverModel = {
      title: null,
      subTitle: null,
      description: null,
      note: null,
      isImportant: null,
      isDone: null,
    };
    if (this.title) serverModel.title = this.title;
    if (this.subtitle) serverModel.subTitle = this.subtitle;
    serverModel.description = this.description;
    serverModel.note = this.note;
    if (this.labels) serverModel.labels = this.labels;
    serverModel.isImportant = this.importance || false;
    serverModel.isDone = this.done || false;
    Object.keys(serverModel).forEach((key) => {
      if (serverModel[key] === null) {
        delete serverModel[key];
      }
    });
    if (this.singleTaskId) serverModel.singleTaskId = this.singleTaskId;
    return serverModel;
  }

  getTaskDelayed(serverModel) {
    this.id = serverModel.id || '';
    this.extId = serverModel.extId || '';

    this.type = getTaskType(false, false, true);

    this.title = serverModel.title || '';
    this.subtitle = serverModel.subTitle || '';
    this.description = serverModel.description || '';
    this.note = serverModel.note || '';

    this.importance = serverModel.isImportant || false;
    this.done = serverModel.isDone || false;

    this.labels = serverModel.labels || [];

    return this;
  }
}

export default TaskDelayed;
